var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"FilterBar"},[_c('div',{staticClass:"d-flex flex-wrap gap"},[_vm._t("default")],2),_c('div',{staticClass:"dropdown-divider my-4"})])
}
var staticRenderFns = []

export { render, staticRenderFns }